export default __webpack_public_path__ + "static/FeaturesBannerMobImg-0e6289bc4ae66fb36be5f5cb15898322.png";